import TwoStepSuccess from './TwoStepSuccess';

export default TwoStepSuccess;
